import styled from 'styled-components';

export const CardShopContainer = styled.div`
    display: flex;
    width: fit-content;
    background-color: ${({ theme }) => theme.colors.primary};
    border-radius: 1.5rem;
    box-shadow: 0px 0px 2px 2px rgb(0, 0, 0, 0.1);
    overflow: auto;

    button {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        border: none;
        background: none;
        cursor: pointer;
        border-radius: 0.75rem;
        padding: 0.5rem 0.75rem;
        transition: 0.05s;

        p {
            color: var(--Neutral-950, #09090b);
            font-size: 1rem;
            font-weight: 700;
            line-height: 1.5rem;
        }

        svg {
            width: 1.5rem;
            height: 1.5rem;
        }
    }

    .vertical-divider {
        background-color: #f7f7f7;
    }
`;

export const LeftArea = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding: 0.75rem;
    min-width: 15rem;
    padding-bottom: 5rem;

    button:hover,
    button[aria-selected='true'] {
        background: var(--Supernova-500, #ffcf00);
        color: var(--Supernova-950, #442404);
    }
`;

export const RightArea = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding: 0.75rem;
    min-width: 15rem;
    max-width: 15rem;
    background: var(--Silver-50, #f7f7f7);

    button {
        color: var(--Neutral-950, #09090b);
        font-family: 'Hero New';
        font-size: 1rem;
        font-style: normal;
        font-weight: 700;
        line-height: 1.5rem;

        &:hover {
            background: var(--Supernova-500, #d7d7d771);
        }
    }

    img.carousel {
        height: 10rem;
        flex-grow: 1;
        aspect-ratio: 1/1;
    }
`;

export const SVGWrap = styled.div`
    div {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    svg {
        height: 1.5rem;
        width: 1.5rem;
    }
`;
